import { render, staticRenderFns } from "./salesbookkeepingTemplate.vue?vue&type=template&id=20667bde&scoped=true"
import script from "./salesbookkeepingTemplate.vue?vue&type=script&lang=js"
export * from "./salesbookkeepingTemplate.vue?vue&type=script&lang=js"
import style0 from "./salesbookkeepingTemplate.vue?vue&type=style&index=0&id=20667bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20667bde",
  null
  
)

export default component.exports